import React from "react";

const Product = ({ title, para, image, mainColor, translations }) => {
  const shopNowText = translations?.result?.ShopNow || "Shop Now";

  return (
    <div
      className="product-card"
      data-aos="fade-right"
      data-aos-duration="2000"
      style={{ backgroundImage: `url(${image})` }}
    >
      <div className="row card-responsive">
        <div className=" product-card-content">
          <div
            className="product-card-text"
            id={`${mainColor ? "main-color" : "secondary-color"}`}
          >
            <div className="product-card-copy">
              <h2>{title}</h2>
            </div>
            {para ? (
              <p className="product-para">{para}</p>
            ) : null}
            <div className="d-flex">
              <button type="button">{shopNowText}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Product;
